import { render } from "./RadioCards.vue?vue&type=template&id=428e03d2"
import script from "./RadioCards.vue?vue&type=script&lang=js"
export * from "./RadioCards.vue?vue&type=script&lang=js"

import "./RadioCards.vue?vue&type=style&index=0&id=428e03d2&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__